import { EventSubscriber } from 'typeorm'

import { HistoryEntitySubscriber } from '@operato/typeorm-history'

import { Kpi } from './kpi'
import { KpiHistory } from './kpi-history'

@EventSubscriber()
export class KpiHistoryEntitySubscriber extends HistoryEntitySubscriber<Kpi, KpiHistory> {
  public get entity() {
    return Kpi
  }

  public get historyEntity() {
    return KpiHistory
  }

  public async afterInsert(event): Promise<void> {
    if (event.entity.state == 'RELEASE') {
      await super.afterInsert(event as any)
    }
  }

  public async afterUpdate(event): Promise<void> {
    if (event.entity.state == 'RELEASE') {
      await super.afterUpdate(event as any)
    }
  }
}
